import { IconNoResult } from '@picsart/design-system/foundation/icons/IconNoResult';
import {
  Button,
  ButtonElementTypes,
  ButtonSkinPrimary,
} from '@picsart/design-system/components/Button';

import { useTranslator } from '@picsart/rc/services/localization';

import { useNavigate } from 'react-router-dom';
import noResultData from './data';

import useStyles from './styles';

function NoResult() {
  const { title, description, buttonLabel } = noResultData;
  const translate = useTranslator();
  const navigate = useNavigate();

  const redirectToMain = () => {
    navigate('/sizes');
  };

  const styles = useStyles();
  return (
    <section className={styles.wrapper} data-pulse-section="no-result">
      <IconNoResult className={styles.icon} />
      <p className={styles.title}>{translate(title)}</p>
      <span className={styles.description}>{translate(description)}</span>
      <Button
        skin={ButtonSkinPrimary}
        tag={ButtonElementTypes.Link}
        data-pulse-name={buttonLabel}
        onClick={redirectToMain}
      >
        {translate(buttonLabel)}
      </Button>
    </section>
  );
}

export default NoResult;
